import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PaginationModule } from '@shared/pagination/pagination.module';
import {
  BillingHistoryComponent,
  BillingHistorySearchAdminComponent,
  BillingHistorySearchComponent,
  BillingHistoryTableAdminComponent,
  BillingHistoryTableUserComponent,
} from './components';
import { IconsModule } from '@shared/icons/icons.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { BillSharedModule } from '@shared/bill-shared/bill-shared.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { PopoverBoxComponent } from '@app/shared/components';

@NgModule({
  declarations: [
    BillingHistoryComponent,
    BillingHistorySearchComponent,
    BillingHistoryTableAdminComponent,
    BillingHistoryTableUserComponent,
    BillingHistorySearchAdminComponent,
    PopoverBoxComponent,
  ],
  imports: [
    CommonModule,
    CustomModalModule,
    MutualModule,
    PaginationModule,
    IconsModule,
    PipesSharedModule,
    NgxPaginationModule,
    NzToolTipModule,
    NzPopoverModule,
    BsDropdownModule.forRoot(),
    BillSharedModule,
  ],
  exports: [
    BillingHistoryComponent,
    BillingHistorySearchComponent,
    BillingHistoryTableAdminComponent,
    BillingHistoryTableUserComponent,
    BillingHistorySearchAdminComponent,
    PopoverBoxComponent,
  ],
})
export class BillingHistorySharedModule {}
